var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10808",
    "data-name": "Group 10808",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.375,
    height: 25.375,
    viewBox: "0 0 25.375 25.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10979",
    "data-name": "Path 10979",
    d: "M12.688,0A12.688,12.688,0,1,1,0,12.688,12.688,12.688,0,0,1,12.688,0Z",
    transform: "translate(0 0)",
    fill: "#faf8f8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "collapse",
    transform: "translate(6.13 12.688)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y2: 12.91,
    transform: "translate(12.91) rotate(90)",
    fill: "none",
    stroke: "#003049",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus_icon.efde2b0ef1741daae9dd5ce578be250b.svg";
export { ForwardRef as ReactComponent };